import React, { useState } from "react";
import GenericTagComp from "../genericComponents/tag/GenericTagComp";
import TextWithTooltip from "../GlobalContacts/TextWithTooltip";
import "./OppCardViewContainer.css";
import { normalizeMappedProducts } from "../../../utilities/uiUtils";

const baseColumns = [
  { id: "opportunity_name", label: "Name" },
  { id: "opportunity_description", label: "Description" },
  { id: "mapped_products", label: "My Offerings" },
  { id: "relevance", label: "Relevance" },
  { id: "signal", label: "Signal" },
];

export default function OppCardViewContainer({ data}) {
  return (
    <>
    <div
        style={{
          fontSize: "16.8px",
          fontWeight: "600",
          marginBottom: "0.8rem",
          marginTop: "1rem",
          marginLeft: "0.5rem",
          color: "#111827",
          letterSpacing: "0.3px",
        //   backgroundColor: "#e4e6e9",
          
        }}
      >
        {data.length} Opportunities Found
      </div>
    <div className="opp-card-list-ocv">
      {data?.map((item, index) => (
        <OppCard key={index} item={item} />
      ))}
    </div>
    </>
  );
}

function OppCard({ item }) {
  const [expandDesc, setExpandDesc] = useState(false);
  const DESC_LIMIT = 250;

  const mappedProductsArray = normalizeMappedProducts(item?.mapped_products)
  
  

  const descriptionText = item?.opportunity_description || "";
  const showMoreDesc = descriptionText.length > DESC_LIMIT;

  return (
    <div className="opp-card-ocv">
      {baseColumns.map((col) => {
        let value = item[col.id];
        if (col.id === "opportunity_name") {
          
           return (
            <div className="opp-section-ocv" key={col?.id}>
              <div className="opp-name-header-ocv">
                <div className="opp-section-title-ocv">{col?.label}</div>

                {/* <button className="opp-save-btn-ocv">
                  Save Opportunity
                </button> */}
              </div>

              <div className="opp-section-value-ocv">
                {item.opportunity_name || "-"}
              </div>
            </div>
          );
        }

        if (col.id === "opportunity_description") {
          value = (
            <div
              className={
                expandDesc ? "opp-desc-expanded-ocv" : "opp-desc-clamp-ocv"
              }
            >
              {descriptionText}
            </div>
          );
        }

        if (col.id === "mapped_products") {
          value = (
            <div className="opp-chips-ocv">
              {mappedProductsArray.map((prod, i) => (
                <GenericTagComp key={i} text={prod} />
              ))}
            </div>
          );
        }

        return (
          <div className="opp-section-ocv" key={col?.id}>
            <div className="opp-section-title-ocv">{col?.label}</div>
            <div className="opp-section-value-ocv">{value || "-"}</div>

            {col.id === "opportunity_description" && showMoreDesc && (
              <div className="opp-show-more-container-ocv">
                <button
                  className="opp-show-more-btn-ocv"
                  onClick={() => setExpandDesc(!expandDesc)}
                >
                  {expandDesc ? "Show less" : "Show more"}
                </button>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
